/**
 * Resolves the API base URL.
 *
 * Strategy:
 * - In production (i.e. served from a domain that LOOKS like a real prod host
 *   = anything that's not the Emergent preview/host technical URL), use the
 *   current origin so requests stay same-origin → no CORS.
 * - In development / preview (preview.emergentagent.com or emergent.host),
 *   fall back to `process.env.REACT_APP_BACKEND_URL` injected at build time,
 *   then to `window.location.origin` as a final fallback.
 *
 * This makes the build artifact portable across domains: you can serve the
 * same bundle from metaconnect.fr or app.example.com without rebuilding.
 */
function isInternalEmergentHost(host) {
  return /\.preview\.emergentagent\.com$/i.test(host) || /\.emergent\.host$/i.test(host);
}

// Build-time prerender (puppeteer hitting a local static server) and local dev
// access via 127.0.0.1 / localhost must NOT call same-origin — there is no API
// running on that host. Fall back to the configured REACT_APP_BACKEND_URL.
function isLocalLoopback(host) {
  return /^127\.0\.0\.1(:\d+)?$/i.test(host) || /^localhost(:\d+)?$/i.test(host) || /^\[::1\](:\d+)?$/i.test(host);
}

export function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return envUrl;
  const currentHost = window.location.host;
  if (isInternalEmergentHost(currentHost) || isLocalLoopback(currentHost)) {
    // Preview / emergent.host technical URL / local prerender — use the env
    // value (which points to the real backend) so dev tooling keeps working.
    return envUrl || window.location.origin;
  }
  // Real production domain (e.g. metaconnect.fr) — always call same-origin.
  return window.location.origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
